import { render, staticRenderFns } from "./GetPricing.vue?vue&type=template&id=d3496ed8&scoped=true&"
import script from "./GetPricing.vue?vue&type=script&lang=js&"
export * from "./GetPricing.vue?vue&type=script&lang=js&"
import style0 from "./GetPricing.vue?vue&type=style&index=0&id=d3496ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3496ed8",
  null
  
)

export default component.exports